import formikData, {
  FormValues
} from 'screens/Applications&WorkOrders/StepsLayout/Constants/formikData';

interface WorkOrderFormValues
  extends Omit<
    FormValues,
    'durationHours' | 'durationMinutes' | 'endDateTime' | 'weather'
  > {}

const {
  durationHours,
  durationMinutes,
  weather,
  endDateTime,
  ...initialWorkOrder
} = formikData.initialValues;

const initialWorkOrderValues: WorkOrderFormValues = {
  ...initialWorkOrder
};

const createWorkOrderValidationSchema = formikData.validationSchema.omit([
  'durationHours',
  'durationMinutes',
  'endDateTime',
  'weather'
]);

export default {
  initialValues: initialWorkOrderValues,
  validationSchema: createWorkOrderValidationSchema
};
